// extracted by mini-css-extract-plugin
export default {"team":"team_K4mQ1","left":"left_qyiFJ","right":"right_pMKTN"};